<template>
    <div class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>Loading...</p>
    </div>
</template>